import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/MyTask/myTaskCustomer.html'
})

export class MyTaskCustomerComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public myTask :any[];
    public taskGroupList:any[];
    public filterTaskTypeStatus:any=""; 
    public filterTasktype:any="";
    public taskType:any[];
 public filter:any={'Tasktype':"",'TaskGroup':"",'ProjectId':"",'AssignedTo':"",'TaskOwner':"",'CreatedBy':"",'ByCreatedDate':false,'ByCurrent':false,'ByOverDue':false,'ByOpen':false,'ByClose':false,'Search':""};
    public isAdd: boolean = true;
    active = true;
    public showLoader = false;
    public isFormSubmitted: boolean = false;
    public projectList:any[];
    public filterFlag: any;
    public usersItems:any[];
     constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filterFlag=JSON.parse(localStorage.getItem('TaskFilters'));
        if(this.filterFlag!=null && typeof this.filterFlag != 'undefined'){
          this.filter=JSON.parse(localStorage.getItem('TaskFilters'));
        }
         
          localStorage.removeItem("TaskFilters")
      
    }

     newForm() {
         this.active = false;
         setTimeout(() => this.active = true, 0);
     }

    ngOnInit() {
      
        this.getMyTask();
        this.GetTaskGroupList();
        this.GetTaskType();
        this.GetProjectList();

    }


    ngAfterViewInit() {

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public AddTeamFormLoad() {
        $('#btnAddTeamForm').trigger('click');
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }
     public clearFilter() {

        this.filter={'Tasktype':"",'TaskGroup':"",'ProjectId':"",'AssignedTo':"",'TaskOwner':"",'CreatedBy':"",'ByCreatedDate':false,'ByCurrent':false,'ByOverDue':false,'ByOpen':false,'ByClose':false,'Search':""}; 
       
     }

    setFilters() {
  
        this.filter = {  'Tasktype':this.filter.Tasktype,'TaskGroup':this.filter.TaskGroup,'ProjectId':this.filter.ProjectId,'AssignedTo':this.filter.AssignedTo,'TaskOwner':this.filter.TaskOwner,'CreatedBy':this.filter.CreatedBy,'ByCreatedDate':this.filter.ByCreatedDate,'ByCurrent':this.filter.ByCurrent,'ByOverDue':this.filter.ByOverDue,'ByOpen':this.filter.ByOpen,'ByClose':this.filter.ByClose,'Search': this.filter.Search };
        localStorage.setItem("TaskFilters",JSON.stringify(this.filter));
    }


    public GetTaskGroupList() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetTaskGroupList', {"TaskTypeId": 0, "TaskGroupId":0}).subscribe(
            data => {
                this.taskGroupList = data["TaskGroupList"];
                console.log(this.taskGroupList);
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
                

            }
        );
    }

   

   
    GetProjectList() {
        this.showLoader=true;

        var CustomerId = 0;
        if(this.userDetail.CustomerId != null)
        {
            CustomerId = this.userDetail.CustomerId;
        }
        
        this._httpService.ajaxPost("Project/GetCustomerProject", { "ProjectId": 0, "CustomerId": CustomerId}).subscribe(
            data => {
               
                this.projectList = data["ProjectList"];  
                if(this.projectList != null && this.projectList.length > 0)
                {
                    var projectId ="";
                    this.projectList.forEach(element => {
                        if(projectId == "")
                        {
                            projectId = String(element.Project_Id); 
                        }
                        else
                        {
                            projectId = projectId + ","+String(element.Project_Id); 
                        }
                    });
                    this.getUsers(projectId);   
                }
                else
                {
                    this.getUsers(0);   
                }              
            },
            err => { console.log("GetProjectList Failed");this.showLoader=false;},
            () => {
               
                this.showLoader=false;
            }
            );
    }

    public getUsers(projectid) {
       
       
        this._httpService.ajaxPost("TimeSheet/GetUserListByProjects",
            {   "Project_Id": projectid,
                "IsActive": this.constants.enumUserStatus["Active"],
                "Team_Id":"0",
                "ProjectType": 0,
                "Status": 1,
                "UserId": 0
            }).subscribe(
            data => {
                this.usersItems = data["Users"];
                this.filter.CreatedBy="";
                this.filter.TaskOwner="";
                this.filter.AssignedTo="";
            }
            );
       
    }

   
    public GetTaskType() {
        this.showLoader = true;
        
        this._httpService.ajaxPost('TaskType/GetTaskTypeCustomer', { "TaskTypeId": 0, 
        "TaskGroupId": this.filter.TaskGroup, "IsActive": true,"roleId":this.userDetail.RoleId }).subscribe(
            data => {
                this.taskType = data["TaskType"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }



    public getMyTask() {
        this.showLoader = true;
           if(this.userDetail.RoleId == this.constants.enumUserRole.Executive)
           {
            this.filter.AssignedTo = this.userDetail.SiteUserId;
           }                                                                                                                                                                                              
          this._httpService.ajaxPost('MyTask/GetAllMyTask', { "TaskTypeId":this.filter.Tasktype,"TaskGroup":this.filter.TaskGroup,"ProjectId":this.filter.ProjectId,"AssignedTo":this.filter.AssignedTo,"TaskOwner":this.filter.TaskOwner,"CreatedBy":this.userDetail.SiteUserId,"IsToday":this.filter.ByCreatedDate,"IsCurrent":this.filter.ByCurrent,"IsOverDue":this.filter.ByOverDue,"IsOpen":this.filter.ByOpen,"IsClose":this.filter.ByClose,"LoggedInUser":this.userDetail.SiteUserId}).subscribe(
            data => {
                this.myTask = data["MyTask"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
    
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/MyTask/MyTaskCustomer.component.ts
 **/